export enum GModalConfirmType {
  DEFAULT = 'DEFAULT',
  THEME_EXTENSION = 'THEME_EXTENSION',
}
export interface GModalConfirmInitialValues {
  type?: GModalConfirmType;
  id?: string;
  key?: string;
  title?: string;
  message?: string | React.ReactNode;
  primaryAction?: {
    content: string;
    onAction: () => void | Promise<void>;
  };
  secondaryActions?: {
    content: string;
    onAction: () => void | Promise<void>;
  };
  onSuccess?: () => void;
}
